import React from "react";

// styles
import styles from "./styles.module.scss";

// data
import data from "src/utils/data";

const Category = ({ formData, setFormData }) => {
  const handleClick = (_data) => {
    setFormData({
      ...formData,
      eventCategory: {
        id: _data.Categoryid,
        name: _data.CategoryName,
      },
    });
  };

  return (
    <div className={styles.category__wrapper}>
      <ul>
        {data.by_category.slice(3, data.by_category.length).map((item, i) => (
          <li
            key={i}
            className={
              item.data.Categoryid === formData.eventCategory?.id
                ? styles.active
                : ""
            }
            onClick={() => handleClick(item.data)}
          >
            {item.data.CategoryName}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Category;
